import React from "react";

const Services = () => {
  return <section>Services</section>;
};

export default Services;
